import request from '@/utils/request'

// OIDC免登录结果
export const apiOidcLoginResult = ticket =>
	request({
		url: '/auth/aggregation/utos/oidc/result',
		method: 'post',
		params: {
			ticket,
		},
	})
